import React, { useEffect, useRef, useState } from "react";
import ChatBotSparkles from "../../../assests/chatbot-sparklesIcon.svg";
import ChatbotSendIcon from "../../../assests/chatbot-sendIcon.svg";
import {
  Drawer,
  Divider,
  Image,
  Input,
  Spin,
  Select,
  Card,
  Row,
  Col,
} from "../../common/utils/antd-imports/AntdImports";
import "./chatBotSlideIn.css";
import UserIcon from "../../../assests/user-icon.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchChatBotResponse,
  getChannelsBeforeLogin,
} from "../../../store/thunks/common-thunks/commonThunk";
import { getAllLocations } from "../../../store/thunks/authThunk";
import { useMediaQuery } from "react-responsive";
import { nanoid } from "nanoid";

const ChatBotSlideIn = ({ openChatBot, setOpenChatBot }) => {
  const { Option } = Select;
  const [userQuery, setUserQuery] = useState("");
  const dispatch = useDispatch();
  const userDetails = JSON.parse(localStorage.getItem("user"));
  const sessionId = sessionStorage.getItem("sessionId");
  const [userMessages, setUserMessages] = useState([]);
  const productTypes = ["Static", "Digital", "Static / Digital", "Media"];
  const { isLoading, response } = useSelector((state) => state.chatBot);
  const { isLoading: searchLocationLoader, allLocations } = useSelector(
    (state) => state.location,
  );
  const { isLoading: productChannelsList } = useSelector(
    (state) => state.products,
  );
  const [isDMA, setIsDMA] = useState(false);
  const [isChannel, setIsChannel] = useState(false);
  const [productType, setProductType] = useState(false);
  const [uniqueId, setUniqueId] = useState(sessionId);
  const [userEmail, setUserEmail] = useState("");
  const chatRef = useRef(null);
  const [allProductTypes, setAllProductTypes] = useState("");
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const isTablet = useMediaQuery({ maxWidth: 1024 });
  const greetingSuggestions = [
    "What is AMP?",
    "How does AMP work for advertisers?",
    "How does AMP work for media partners?",
    "What is Docusign?",
  ];
  const greetingUserText =
    "Hi! Welcome to Advertising Marketplace. I'm your AI assistant, here to help advertisers and media partners discover advertising opportunities, manage listings, and get answers about the Advertising Marketplace platform. How can I help you today?";
  const sendAIQuestion = (event, index) => {
    let value = event.target.textContent;
    if (
      value.toLowerCase() === "exit" ||
      value.toLowerCase() === "quit" ||
      value.toLowerCase() === "cancel"
    ) {
      setIsChannel(false);
      setProductType(false);
    }
    sendQuestion(event);
  };
  const sendQuestion = (event) => {
    setUserMessages((prevMessages) => {
      const lockedMessages = prevMessages?.map((message) => ({
        ...message,
        messagesLocked: true,
      }));
      const updatedMessages = [
        ...lockedMessages,
        {
          role: "user",
          message: event.target.textContent,
          suggestions: [],
          messagesLocked: true,
        },
      ];
      return updatedMessages;
    });

    const payload = {
      session_id: uniqueId,
      user_input: event.target.textContent,
      user_id: userDetails?.user ? userDetails?.user?.id?.toString() : "",
    };
    dispatch(fetchChatBotResponse(payload));
  };
  const sendQuestionToAI = () => {
    if (userQuery.trim() != "") {
      setUserMessages((prevMessages) => [
        ...prevMessages,
        {
          role: "user",
          message: userQuery,
          suggestions: [],
          messagesLocked: true,
        },
      ]);
      const payload = {
        session_id: uniqueId,
        user_input: userQuery,
        user_id: userDetails?.user ? userDetails?.user?.id?.toString() : "",
      };
      if (isDMA) dispatch(getAllLocations());
      dispatch(fetchChatBotResponse(payload));
      setUserQuery("");
    }
  };
  const handleSelect = (value, type) => {
    if (type === "location") {
      setIsDMA(false);
      var selectedlocation = allLocations?.find((x) => x.name == value);
      var location = selectedlocation?.city_name + "-" + selectedlocation?.name;
    } else {
      setIsChannel(false);
      let selectedChannel = productChannelsList?.find(
        (x) => x.channel_name == value,
      );
      var channel =
        selectedChannel?.channel_name + "-" + selectedChannel?.sub_channel_name;
    }
    setUserQuery(type === "location" ? location : channel);
    setUserMessages((prevMessages) => [
      ...prevMessages,
      {
        role: "user",
        message: type === "location" ? location : channel,
        suggestions: [],
        messagesLocked: true,
      },
    ]);
    const payload = {
      session_id: uniqueId,
      user_input: value,
      user_id: userDetails?.user ? userDetails?.user?.id?.toString() : "",
    };
    dispatch(fetchChatBotResponse(payload));
    setUserQuery("");
  };

  const handleProductType = (value) => {
    setAllProductTypes(value);
  };
  const sendAllProducts = (event) => {
    if (event.key !== "Enter") {
      event.preventDefault();
      return;
    }
    if (event.key === "Enter") {
      setProductType(false);
      let productTypes =
        allProductTypes != "" ? allProductTypes?.join(", ").toString() : "";
      setUserMessages((prevMessages) => [
        ...prevMessages,
        {
          role: "user",
          message: productTypes,
          suggestions: [],
          messagesLocked: true,
        },
      ]);
    }
    const payload = {
      session_id: sessionId,
      user_input:
        allProductTypes != "" ? allProductTypes?.join(", ").toString() : "",
      user_id: userDetails?.user ? userDetails?.user?.id?.toString() : "",
    };
    dispatch(fetchChatBotResponse(payload));
  };
  const setAllPropsFalse = () => {
    setUserMessages([]);
    setIsChannel(false);
    setIsDMA(false);
    setProductType(false);
    setUserEmail("");
  };
  useEffect(() => {
    if (!isLoading && response) {
      if (response?.response?.products) {
        let topProducts =
          response?.response?.products &&
          Array.isArray(response?.response?.products)
            ? response?.response?.products?.slice(0, 3)
            : [];
        setUserMessages((prevMessages) => [
          ...prevMessages,
          {
            role: "ai",
            message: (
              <div>
                {topProducts.length > 0 ? (
                  <div>
                    {topProducts?.map((product, index) => {
                      return (
                        <Card key={index} style={{ marginBottom: "1rem" }}>
                          <Row gutter={[10, 10]}>
                            <Col className="product-id" span={12}>
                              {product.siteNo}
                            </Col>
                            <Col span={12}>
                              <strong>{product.title}</strong>
                            </Col>
                            <Col span={12}>{product.city_name}</Col>
                            <Col span={12}>Price : ${product.price}</Col>
                          </Row>
                        </Card>
                      );
                    })}
                  </div>
                ) : (
                  <div> {response?.response?.products}</div>
                )}
                {(!userDetails || userDetails?.user?.user_type != "owner") && (
                  <span>
                    Please navigate to{" "}
                    <a
                      href={`${
                        !userDetails
                          ? "/products"
                          : userDetails?.user?.user_type != "owner"
                            ? "/buyer/products"
                            : ""
                      }`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="chatbot-navigation-a"
                    >
                      Products{" "}
                    </a>
                    page to see all the products
                  </span>
                )}
              </div>
            ),
            suggestions: response?.suggestions,
          },
        ]);
      } else {
        const isMobileNumber = response?.response?.includes("mobile number");
        if (isMobileNumber) setUserQuery("+1");
        const isEmail = response?.response
          ?.toLowerCase()
          ?.includes("what is your email");
        if (isEmail) setUserQuery(userEmail);
        const isChannels = response?.response?.includes("channel types");
        if (isChannels) {
          setIsChannel(true);
          dispatch(getChannelsBeforeLogin({ type: [] }));
        }

        setIsDMA(
          response?.response?.includes("geographic areas") ? true : false,
        );
        dispatch(getAllLocations());

        if (response?.response?.includes("product type")) {
          setProductType(true);
        }

        setUserMessages((prevMessages) => [
          ...prevMessages,
          {
            role: "ai",
            message: response?.response,
            suggestions: response?.suggestions,
          },
        ]);
      }
    }
  }, [isLoading, response]);

  const extractSteps = (input) => {
    const match = typeof input === "string" ? input?.match(/^(.+?:)\s*/) : null; // Get intro like "To create a campaign, follow these steps:"
    const heading = match ? match?.[1] : "";
    const body = input?.replace(heading, "")?.trim();

    const steps = body
      ?.split(/(?=\d+\.\s)/) // split by number + dot + space, lookahead to keep delimiters
      ?.filter((part) => /^\d+\.\s/.test(part));
    return { heading, steps, fullText: input };
  };

  const linkifyText = (text) => {
    const urlRegex = /(https?:\/\/[^\s]*\.com[^\s]*)/g;
    // Split text by URLs and map to JSX elements
    return text.split(urlRegex).map((part, index) => {
      if (urlRegex.test(part)) {
        return (
          <a
            className="ai-response-link"
            key={index}
            href={part}
            target="_blank"
            rel="noopener noreferrer"
          >
            {part}
          </a>
        );
      }
      return part;
    });
  };
  useEffect(() => {
    // Set interval to clear AI messages every 30 minutes (1800000 ms)
    const intervalId = setInterval(() => {
      setAllPropsFalse();
      sessionStorage.setItem("sessonId", nanoid());
    }, 1800000);

    // Cleanup on unmount
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    if (chatRef.current) chatRef.current.scrollIntoView({ behavior: "smooth" });
  }, [userMessages]);

  useEffect(() => {
    if (
      userDetails?.message.toLowerCase() == "login successful" ||
      !userDetails?.message
    ) {
      let chatbotId = sessionStorage.getItem("sessionId");
      setUniqueId(chatbotId);
      setUserMessages([]);
      setIsChannel(false);
      setIsDMA(false);
      setProductType(false);
      if (userDetails?.message.toLowerCase()) {
        setUserEmail(userDetails?.user?.email);
      }
    }
  }, [userDetails?.message]);

  useEffect(() => {
    let chatbotId = sessionStorage.getItem("sessionId");
    setUniqueId(chatbotId);
  }, [sessionId]);
  return (
    <div className="chatbot">
      {/* chatbot-slideIn */}
      <Drawer
        width={isMobile ? "100vw" : isTablet ? "58vw" : "32vw"}
        className="ai-assistant"
        title={
          <div className="ai-header">
            Camp<span className="ai">AI</span>gn
            <Image
              className="sparkles-icon"
              src={ChatBotSparkles}
              preview={false}
            />
          </div>
        }
        onClose={() => setOpenChatBot(false)}
        open={openChatBot}
      >
        <Divider className="ai-divider" />
        <div className={`ai-chat-content`} id="chat-assist">
          <div className="ai-guide-content">
            <div className="sparkles-chat-icon">
              <Image src={ChatBotSparkles} preview={false} />
            </div>
            <div className="greeting-text total-greeting-text">
              {greetingUserText}
            </div>
          </div>
          <div className="suggested-questions">
            {greetingSuggestions?.map((suggestedQuestion) => {
              return (
                <div
                  className="user-help"
                  onClick={sendAIQuestion}
                  key={suggestedQuestion}
                >
                  {suggestedQuestion}
                </div>
              );
            })}
          </div>

          {userMessages &&
            userMessages?.map((user, index) => {
              const { heading, steps, fullText } =
                user.role === "ai" &&
                typeof user?.message === "string" &&
                extractSteps(user?.message || "");
              return (
                <div
                  className={`ai-guide-content user-content ${
                    user.role == "user" ? "reverse-direction" : ""
                  }`}
                  key={index}
                >
                  <div className="sparkles-chat-icon user-icon">
                    <Image
                      src={user.role == "user" ? UserIcon : ChatBotSparkles}
                      preview={false}
                    />
                  </div>
                  <br />
                  <div
                    className={`greeting-text ${
                      user.role == "user" ? "add-background" : ""
                    } `}
                  >
                    {user.role === "ai" && typeof user?.message === "string" ? (
                      steps && steps?.length > 0 ? (
                        <>
                          {heading}
                          <ul>
                            {steps?.map((step, i) => {
                              return <li key={i}>{linkifyText(step)}</li>;
                            })}
                          </ul>
                        </>
                      ) : (
                        <> {linkifyText(fullText)} </>
                      )
                    ) : (
                      <> {user?.message}</>
                    )}
                    {user?.suggestions?.[0]?.toLowerCase() === "quit" && (
                      <div className="rfp-exit-text">
                        To exit submitting rfp,
                      </div>
                    )}
                    <span
                      className={`${
                        user?.suggestions?.[0]?.toLowerCase() === "quit"
                          ? "rfp-suggestions"
                          : ""
                      }`}
                    >
                      {user?.suggestions?.map((suggestion, index) => {
                        const isDisabled = user?.messagesLocked;
                        return (
                          <div
                            className={`user-help ${
                              isDisabled ? "no-cursor" : ""
                            }`}
                            key={index}
                            onClick={
                              !isDisabled
                                ? (e) => sendAIQuestion(e, index)
                                : null
                            }
                          >
                            {suggestion}
                          </div>
                        );
                      })}
                    </span>
                  </div>
                </div>
              );
            })}
          {isLoading && (
            <div className="ai-guide-content typing-indicator">
              Generating response
            </div>
          )}
          <div ref={chatRef} />
        </div>
        <div
          className="ai-guide-content input-section"
          style={{ display: "flex" }}
        >
          {!isDMA && !isChannel && !productType && (
            <Input
              className="chat-input"
              value={userQuery}
              placeholder="Type your message"
              onChange={(event) => setUserQuery(event.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter" && !isLoading) {
                  setUserQuery(e.target.value);
                  sendQuestionToAI();
                }
              }}
              suffix={
                <span>
                  <Image
                    className={`sendIcon ${isLoading ? "disable-send" : ""}`}
                    src={ChatbotSendIcon}
                    onClick={!isLoading ? sendQuestionToAI : undefined}
                    preview={false}
                  />
                </span>
              }
            />
          )}

          {(isChannel || isDMA) && (
            <div>
              <Select
                showSearch
                optionFilterProp="children"
                placeholder={isChannel ? "Select Channel" : "Select Location"}
                className="chatbot-select-location-css"
                onChange={(value) =>
                  handleSelect(value, isChannel ? "channel" : "location")
                }
              >
                {isChannel ? (
                  productChannelsList?.map((channel) => (
                    <Option key={channel.id} value={channel.channel_name}>
                      {channel.channel_name} - {channel.sub_channel_name}
                    </Option>
                  ))
                ) : searchLocationLoader ? (
                  <div className="chatbot-select-location-spinner">
                    <Spin size="small" />
                  </div>
                ) : (
                  allLocations?.map((location) => (
                    <Option key={location.id} value={location.name}>
                      {location.city_name + "-" + location.name}
                    </Option>
                  ))
                )}
              </Select>
            </div>
          )}

          {productType && (
            <Select
              showSearch
              mode="multiple"
              placeholder="Select Product Type"
              className="chatbot-select-location-css"
              onKeyDown={sendAllProducts}
              onChange={(value) => handleProductType(value)}
            >
              {[...new Set(productTypes)]?.map((productType, index) => (
                <Option key={"product" + index} value={productType}>
                  {productType}
                </Option>
              ))}
            </Select>
          )}
        </div>
      </Drawer>
    </div>
  );
};

export default ChatBotSlideIn;
